module.exports = __webpack_public_path__ + "static/media/icon-bank.b6694b09.svg";